import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListeCarteImageTitreLien } from '@components/liste-carte-image-titre-lien/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { LinkDirective } from '@shared/directives';

@Component({
  selector: 'app-liste-carte-image-titre-lien',
  templateUrl: './liste-carte-image-titre-lien.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OptionCardComponent, LinkDirective, SvgComponent],
})
export class ListeCarteImageTitreLienComponent extends AbstractDynamicComponent<ListeCarteImageTitreLien> {}
